export default {
  init() {
    // JavaScript to be fired on the home page
    jQuery(function ($) {
      $('#partnership-guidelines-view-pdf').click(function() {
        ga('send', 'event', 'Downloads', 'Downloaded Partnership Guidelines', 'PDF file in Mortgage Lending for Credit Unions and Community Banks page');
      });
      $('#partner-with-us').click(function() {
        ga('send', 'event', 'Internal Clicks', 'Clicked Partner With Us', 'Button in Mortgage Lending for Credit Unions and Community Banks page');
      });
    });
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/creditunions.js